import { render, staticRenderFns } from "./AHUser.vue?vue&type=template&id=247d6712&"
import script from "./AHUser.vue?vue&type=script&lang=ts&"
export * from "./AHUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports